if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButtonCustom extends DetailsDisclosure {
      // 分享链接模板
      linkTemplates = {
        instagram: 'instagram://share?url=${share_link}',
        facebook: 'https://www.facebook.com/sharer/sharer.php?u=${share_link}',
        twitter: 'https://x.com/intent/post?text=&url=${share_link}',
        reddit: 'https://www.reddit.com/submit?url=${share_link}&title=${share_title}',
      };
      isCloseing = false;

      constructor() {
        super();

        this.elements = {
          ShareButtonCustom: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          links: this.querySelectorAll('a[href]'),
          instagram: this.querySelector('.share__instagram[type="instagram"]'),
        };
        this.urlToShare = this.getAttribute('data-share-link');

        this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));

        this.elements.shareSummary.addEventListener('click', (e) => {
          if (this.mainDetailsToggle.hasAttribute('open')) {
            this.closeDetails();
          } else {
            this.openDetails();
          }
          // Check if the event target is a link
          // console.log(e.target)
          // if (e.target.tagName.toLowerCase() == 'a') {
          //     // Allow the default action
          //     return;
          // }
          e.preventDefault();
        });

        const isTouchDevices = ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
        if (!isTouchDevices) {
          this.addEventListener('mouseenter', () => {
            this.openDetails();
          });
          this.addEventListener('mouseleave', () => {
            this.closeDetails();
          });
        }

        if (!this.checkMobileDevices() && this.elements.instagram) {
          this.elements.instagram.style.display = 'none';
        }

        this.elements.instagram.addEventListener('click', (e) => {
          this.isInstagramInstalled();
          e.preventDefault();
        });
      }

      openDetails() {
        if (this.isCloseing) return;
        this.mainDetailsToggle.setAttribute('open', '');
      }

      closeDetails() {
        if (this.isCloseing) return;
        this.isCloseing = true;
        this.mainDetailsToggle.classList.add('closing')
        setTimeout(() => {
          this.mainDetailsToggle.removeAttribute('open');
          this.isCloseing = false;
          this.mainDetailsToggle.classList.remove('closing')
        }, 300);
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.shareSummary.focus();
        }
      }

      updateUrl(url) {
        if (!url) return;

        this.urlToShare = url;
        this.setAttribute('data-share-link', url);
        for (const link of this.elements.links) {
          const type = link.getAttribute('type');
          if (!type) continue;

          const template = this.linkTemplates[type];
          if (!template) continue;

          const fullLink = this.generateLink(template, url);
          if (fullLink) link.setAttribute('href', fullLink);
        }
      }

      generateLink(template, shareLink) {
        if (!template || !shareLink) return null;

        return template
          .replace(/\$\{share_link\}/g, encodeURIComponent(shareLink))
          .replace(/\$\{share_title\}/g, encodeURIComponent(document.title));
      }

      checkMobileDevices() {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/android/i.test(userAgent) || (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)) {
          return true;
        } else {
          return false;
        }
      }

      isInstagramInstalled() {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/android/i.test(userAgent)) {
          const link = `intent://share?url=${this.urlToShare}#Intent;package=com.instagram.android;scheme=instagram;end`;
          window.location.href = link;
          return link;
        }
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          const link = `instagram://share?url=${this.urlToShare}`;
          window.location.href = link;
          // 如果在500毫秒内没有跳转回来，假定用户没有安装应用
          // setTimeout(function () {
          //   if (window.location.href.indexOf('about:blank') === -1) {
          //     // 用户已经回到了原页面，说明没有安装应用
          //     alert("Instagram app is not installed!");
          //   } else {
          //     // 用户被导向到了App Store或者其他页面，说明已经安装了应用
          //     console.log('App installed');
          //   }
          // }, 500)
          return link;
        }
        alert("Instagram app is not installed!");
        return false;
      }
    }
  );
}
